import React from "react";

import { Box, Container, Divider, Grid, List, ListItem, ListItemText, ListSubheader, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import { CostChapter, selectCurrentChapter, setCurrentChapter } from "modules/customer/insights/cost/costSlice";
import { useAppDispatch, useAppSelector } from "store";

import Filters from "pages/customer/insights/cost/insight/filters/Filters";
import ClusterStoresFilter from "./ClusterStoresFilter";

const Navigation: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const currentChapter = useAppSelector(selectCurrentChapter);

    const chooseChapter = (newChapter: CostChapter) => {
        dispatch(setCurrentChapter(newChapter));
    };

    return (
        // @ts-ignore
        <Box bgcolor={theme.palette.background.insight} position="fixed" height="100vh" width={theme.spacing(45)}>
            <Container maxWidth={false}>
                <Grid container>
                    <Grid md={12}>
                        <Box paddingTop={1} paddingBottom={2} display="flex" alignItems="center">
                            <Typography variant="h3" >
                                Costs
                            </Typography>
                        </Box>
                    </Grid>
                    {(currentChapter === CostChapter.StoreCosts || currentChapter === CostChapter.StoreCostActions) && (
                        <>
                            <Spacer />
                            <Grid md={12}>
                                <Box paddingBottom={2}>
                                    <Filters />
                                </Box>
                            </Grid>
                            <Grid md={12}>
                                <Box paddingBottom={2}>
                                    <ClusterStoresFilter />
                                </Box>
                            </Grid>
                        </>
                    )}
                </Grid>
                <Divider />
                <Box paddingTop={2} paddingBottom={2}>
                    <List disablePadding>
                        <ListSubheader disableGutters>
                            Estate
                        </ListSubheader>
                        <ListItem
                            button
                            selected={currentChapter === CostChapter.CostOverview}
                            onClick={() => chooseChapter(CostChapter.CostOverview)}
                        >
                            <ListItemText primary="Cost overview" />
                        </ListItem>
                        <ListItem
                            button
                            selected={currentChapter === CostChapter.CostDrivers}
                            onClick={() => chooseChapter(CostChapter.CostDrivers)}
                        >
                            <ListItemText primary="Cost drivers" />
                        </ListItem>
                        <ListSubheader disableGutters>
                            Store
                        </ListSubheader>
                        <ListItem
                            button
                            selected={currentChapter === CostChapter.StoreCosts}
                            onClick={() => chooseChapter(CostChapter.StoreCosts)}
                        >
                            <ListItemText primary="Store costs" />
                        </ListItem>
                        <ListItem
                            button
                            selected={currentChapter === CostChapter.StoreCostActions}
                            onClick={() => chooseChapter(CostChapter.StoreCostActions)}
                        >
                            <ListItemText primary="Store cost actions" />
                        </ListItem>
                    </List>
                </Box>
            </Container>
        </Box>
    );
};

export default Navigation;
